import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

export default function About() {
    return (
        <Box
            id="about"
            sx={{
                width: '100%',
                background: 'linear-gradient(180deg, #1a1a1a, #1f1f1f)',
                py: 6, // Padding for spacing
            }}
        >
            <Container maxWidth="lg">
                <Grid container justifyContent="center">
                    <Grid item xs={false} sm={2}></Grid>
                    <Grid item xs={12} sm={8}>
                        <Box sx={{ textAlign: 'center', color: 'white' }}>
                            <Typography
                                variant="h2"
                                sx={{
                                    fontSize: '32px',
                                    fontWeight: '600',
                                    mb: 2,
                                }}
                            >
                                About Us
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontSize: '16px',
                                    color: 'rgba(255, 255, 255, 0.85)',
                                }}
                            >
                                CloudSec Network (CSN) is a community-driven platform that empowers individuals and organizations with hands-on training in
                                cybersecurity and cloud engineering, realistic cybersecurity simulations, and access to a global network of industry experts.                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={false} sm={2}></Grid>
                </Grid>
            </Container>
        </Box>
    );
}
